import { useSelector } from 'react-redux';
const HasPermission = (permission) => {
    const { authUser } = useSelector(({ auth }) => auth);
    return authUser.user.userRoles.some(x => permission && permission.includes(x.userRole));
};

export default HasPermission;

